
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as convert_45trialfZpqD84epoMeta } from "/home/kwesterfeld/ybd/ui/portal/src/pages/convert-trial.vue?macro=true";
import { default as indexLtKXYlw8WxMeta } from "/home/kwesterfeld/ybd/ui/portal/src/pages/index.vue?macro=true";
export default [
  {
    name: "portal-convert-trial",
    path: "/convert-trial",
    meta: convert_45trialfZpqD84epoMeta || {},
    component: () => import("/home/kwesterfeld/ybd/ui/portal/src/pages/convert-trial.vue")
  },
  {
    name: "portal-main",
    path: "/",
    meta: indexLtKXYlw8WxMeta || {},
    component: () => import("/home/kwesterfeld/ybd/ui/portal/src/pages/index.vue")
  }
]